import { useState } from 'react';
import { ArtChip, Identicon, ArtActionMenu } from '@art/shared-ui';
import { Dialog, DialogContent, List, Typography, Grid2, Link, Divider, AvatarGroup, Avatar, DialogTitle } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';

const EmailRuleCard = ({ rule, removeRule, editRule }: any) => {
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);

    const menuOptions = [
        {
            label: 'Edit',
            value: 'edit',
            icon: <Edit color="action" />,
            actions: [() => editRule(rule)]
        },
        {
            label: 'Delete',
            value: 'delete',
            icon: <Delete color="action" />,
            actions: [() => { removeRule(rule?._id); }]
        },
    ];

    return (
        <Grid2 size={{ xs: 12, sm: 12, md: 12, xl: 4 }}>
            <div
                style={{
                    padding: 12,
                    marginTop: 4,
                    border: '1px solid #e0e0e0',
                    borderRadius: 8
                }}
            >
                <Grid2 container spacing={1} alignItems="center">
                    <Grid2 size={10}>
                        <Typography sx={{ mb: 2 }}>
                            <b>Threshold</b> &nbsp;
                            <ArtChip
                                size="small"
                                variant="outlined"
                                label={`${rule.gt_percentage}%`}
                                sx={{ fontSize: 10 }}
                            />
                        </Typography>
                    </Grid2>
                    <Grid2 size={2} sx={{textAlign:"end"}}>
                        <ArtActionMenu options={menuOptions} />
                    </Grid2>
                </Grid2>
                <div style={{ marginTop: 8 }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, flexWrap: 'wrap' }}>
                        <AvatarGroup sx={{ flexShrink: 0 }}>
                            <Avatar sx={{ bgcolor: "#ede6e6", color: "#333", fontSize: 12, fontWeight: "bold", width: 32, height: 32 }}>
                                {rule.emails[0].slice(0, 2).toUpperCase()}
                            </Avatar>
                            {rule.emails.length > 1 && (
                                <Avatar sx={{ bgcolor: "#ccc", color: "#fff", fontSize: 12, width: 32, height: 32 }}>
                                    +{rule.emails.length - 1}
                                </Avatar>
                            )}
                        </AvatarGroup>

                        <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
                            <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                Notification sent to
                            </Typography>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                                <Typography
                                    variant="body2"
                                
                                >
                                    {rule.emails[0]}
                                </Typography>
                                {rule.emails.length > 1 && (
                                    <Link
                                        component="button"
                                        variant="body2"
                                        onClick={() => setIsEmailModalOpen(true)}
                                        sx={{ fontSize: 12, flexShrink: 0 }}
                                    >
                                        +{rule.emails.length - 1}
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                </div>


                <Dialog
                    open={isEmailModalOpen}
                    onClose={() => setIsEmailModalOpen(false)}
                    // sx={{width: 400}}
                    maxWidth="xs"
                    fullWidth
                >
                    <DialogTitle>User Email</DialogTitle>
                    <Divider />
                    <DialogContent>
                        <List>
                            {rule?.emails?.length > 0 ? rule?.emails.map((email: any, index: any) => (
                                <div key={index} className='d-flex align-items-center justify-content-start column-gap-2 mb-2'>
                                    <Identicon
                                        size={26}
                                        value={email.slice(0, 2).toUpperCase()}
                                        config={{
                                            backColor: "#ede6e6",
                                            padding: 0.12
                                        }}
                                        style={{ borderRadius: "50%" }}
                                    />
                                    <Typography variant='body2' color='default'>{email}</Typography>
                                </div>
                            )) : <Typography variant='body2' color='default'>Oops! We couldn’t find any emails for your search.</Typography>}
                        </List>
                    </DialogContent>
                </Dialog>
            </div>
        </Grid2>
    );
};

const EmailRulesList = ({ rules, removeRule, editRule }: any) => {
    return (
        <Grid2 container spacing={1} sx={{ mt: 2 }}>
            {rules.map((rule: any) => (
                <EmailRuleCard key={rule?._id} rule={rule} removeRule={removeRule} editRule={editRule} />
            ))}
        </Grid2>
    );
};

export default EmailRulesList;